import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

export default function PricingTable({ programs, table, onSelect }) {
  return (
    <div className="bg-[#111111] border border-[#262626] overflow-hidden mb-6" data-testid="tuition-table">
      <Table>
        <TableHeader>
          <TableRow className="border-[#262626] hover:bg-transparent bg-[#0A0A0A]">
            <TableHead className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3] font-heading py-4 px-6">
              {table.program}
            </TableHead>
            <TableHead className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3] font-heading py-4 px-6">
              {table.duration}
            </TableHead>
            <TableHead className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3] font-heading py-4 px-6">
              {table.price}
            </TableHead>
            <TableHead className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3] font-heading py-4 px-6 hidden sm:table-cell">
              {table.includes}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {programs.map((row, i) => (
            <TableRow
              key={row.program}
              className="border-[#262626] hover:bg-[#1a1a1a] transition-colors cursor-pointer group"
              data-testid={`tuition-row-${i}`}
              onClick={() => onSelect(i)}
            >
              <TableCell className="text-sm text-white font-body font-semibold py-5 px-6 group-hover:text-[#FF3B30] transition-colors">
                {row.program}
              </TableCell>
              <TableCell className="text-sm text-[#A3A3A3] font-body py-5 px-6">
                {row.duration}
              </TableCell>
              <TableCell className="font-heading text-xl text-white py-5 px-6">
                {row.price}
              </TableCell>
              <TableCell className="text-sm text-[#A3A3A3] font-body py-5 px-6 hidden sm:table-cell">
                {row.includes}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="px-6 py-3 border-t border-[#262626] text-center">
        <span className="text-xs text-[#555] font-body">Click any row for full breakdown</span>
      </div>
    </div>
  );
}
